<template>
<div class="chapter">
<div class="inner_page">
<p class="western2" id="calibre_pb_1"><img alt="tmp_f099aff482e799492a35054ee1867e1f_WrMliK_html_m2699f02.gif" class="calibre2" id="Picture_3" src="tmp_f099aff482e799492a35054ee1867e1f_WrMliK_html_m2699f02.gif"/></p>
<p class="western3"> <br class="calibre3"/></p>
<h3 class="western4">JAMES CRAWFORD</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_f099aff482e799492a35054ee1867e1f_WrMliK.ch.fixed.fc.tidied.stylehacked.xfixed_split_002.vue?c8117366